"use strict";
import { __exports as u } from "./index.es337.js";
import { __require as _ } from "./index.es338.js";
var c;
function d() {
  return c ? u : (c = 1, (function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    });
    function s(n, e) {
      for (var r in e) Object.defineProperty(n, r, {
        enumerable: !0,
        get: e[r]
      });
    }
    s(a, {
      INTERCEPTION_ROUTE_MARKERS: function() {
        return i;
      },
      extractInterceptionRouteInformation: function() {
        return l;
      },
      isInterceptionRouteAppPath: function() {
        return p;
      }
    });
    const f = _(), i = [
      "(..)(..)",
      "(.)",
      "(..)",
      "(...)"
    ];
    function p(n) {
      return n.split("/").find((e) => i.find((r) => e.startsWith(r))) !== void 0;
    }
    function l(n) {
      let e, r, t;
      for (const o of n.split("/"))
        if (r = i.find((R) => o.startsWith(R)), r) {
          [e, t] = n.split(r, 2);
          break;
        }
      if (!e || !r || !t)
        throw Object.defineProperty(new Error("Invalid interception route: " + n + ". Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>"), "__NEXT_ERROR_CODE", {
          value: "E269",
          enumerable: !1,
          configurable: !0
        });
      switch (e = (0, f.normalizeAppPath)(e), r) {
        case "(.)":
          e === "/" ? t = "/" + t : t = e + "/" + t;
          break;
        case "(..)":
          if (e === "/")
            throw Object.defineProperty(new Error("Invalid interception route: " + n + ". Cannot use (..) marker at the root level, use (.) instead."), "__NEXT_ERROR_CODE", {
              value: "E207",
              enumerable: !1,
              configurable: !0
            });
          t = e.split("/").slice(0, -1).concat(t).join("/");
          break;
        case "(...)":
          t = "/" + t;
          break;
        case "(..)(..)":
          const o = e.split("/");
          if (o.length <= 2)
            throw Object.defineProperty(new Error("Invalid interception route: " + n + ". Cannot use (..)(..) marker at the root level or one level up."), "__NEXT_ERROR_CODE", {
              value: "E486",
              enumerable: !1,
              configurable: !0
            });
          t = o.slice(0, -2).concat(t).join("/");
          break;
        default:
          throw Object.defineProperty(new Error("Invariant: unexpected marker"), "__NEXT_ERROR_CODE", {
            value: "E112",
            enumerable: !1,
            configurable: !0
          });
      }
      return {
        interceptingRoute: e,
        interceptedRoute: t
      };
    }
  })(u), u);
}
export {
  d as __require
};
//# sourceMappingURL=index.es313.js.map
